module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0073.png.7bb3b362.jpg";